<template>
    <div>
      <div class="row justify-content-center">
                          <div class=" col-sm-12 grid-margin stretch-card">

                            <div class="card">
                              <div class="card-tile text-center p-2"><h2>Wallets</h2></div>
                              <div class="card-body text-center">
                                <div class="mb-3 row justify-content-center">
                                  <div class="col-sm-8 float-right">
                                  <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">
                                  </div>
                                </div>
                                <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr class="text-center">
                          <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Name</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">All TopUps</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Balance</th>
                           <th class=" text-uppercase  text-xxs font-weight-bolder ">Sms Alert</th>
                           <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data,index) in pageOfItems" :key="data.id" class="text-center">
                          <td>
                            {{index+1}}
                          </td>
                          <td>
                            {{data.phone}}
                          </td>
                          <td >
                            {{data.name}}
                          </td>
                          <td >
                           Ksh. {{formatPrice(data.topup)}}
                          </td>
                          <td  class="text-danger">
                           Ksh. {{formatPrice(data.balance)}}
                          </td>
                          <td >
                          {{ data.sms_alert }}
                          </td>
                          <td >
                         {{ formatDate(data.created_at) }}
                          </td>


                        </tr>

                      </tbody>
                    </table>

                  </div>
                   <div class="row mt-4 justify-content-center">
                        <div class="col-sm-12">
                            <jw-pagination :items="logs"  @changePage="onChangePage" ></jw-pagination>
                        </div>
                    </div>

                              </div>
                            </div>




                            </div>
                            </div>
    </div>
    </template>
    <script>
        import moment from 'moment'
        export default {
            name: 'App',
            components: {

            },
            data(){
                return {
                logs:[],
                 logs2:[],
                message:{id:''},
                  pageOfItems:[],

                }
            },
            created(){
                  this.getWallets();
            },
            methods: {
              onChangePage(pageOfItems) {
                this.pageOfItems = pageOfItems;
            },

              getWallets(){
                    let uri =`/api/auth/getWallets`;
                    this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                       this.logs=response.data;
                       this.logs2=response.data;
                    }).catch(error => {
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
                },

              filter(){
                let filterval=this.message.filterval;
                if(filterval==='' || filterval===null){
                    this.logs=this.logs2;
                }else{
                    let ads =  this.logs2.filter(function(product) {
                        return product.phone.toLowerCase().includes(filterval.toLowerCase()) || product.name.toLowerCase().includes(filterval.toLowerCase())
                    });
                    this.logs=ads;
                }
            },
                formatPrice(value) {
                    let val = (value/1).toFixed(2).replace('.', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
                formatDate(date){
                    return moment(String(date)).format('MM/DD/YYYY HH:mm');
                }

            },
        }

    </script>
